import { array, object, string, type InferType } from 'yup'

// Schema and validation
export interface ObjectId {
	$oid: string
}

export const objectIdSchema = object({
	$oid: string().required()
})

export const locale_int = function(value: any) {
	try {
		return value.toLocaleString('ru-RU', {maximumFractionDigits :0})
	} catch (error) {
		return '-'
	}
}

export const locale_float = function(value: string | number) {
	try {
		return Number(value).toLocaleString('ru-RU', {maximumFractionDigits :2})
	} catch (error) {
		return '-'
	}
}

export const display_short = function(value: any, length: number) {
	try {
		if (value.length > length) {
			const start = value.slice(0, Math.ceil(length / 2))
			const end = value.slice(-Math.floor(length / 2))
			return `${start}...${end}`
		}
		return value
	} catch (error) {
		return value
	}
}

export const user_filter_item_display = (el: User) => {
	let result = `${el?.tg?.first_name || ''} ${el?.tg?.last_name || ''}`

	if (el?.tg?.username) {
		result = `${result} (@${el.tg.username})`
	}
	
	return result
}

export function user_tg_partner_link(user_id: string) {
	return `https://t.me/CryptoSpaceNetworkBot?start=p_${user_id}`
}

export type OrderStatus = 'new' | 'payment_confirmation_wait' | 'expired_payment_wait' | 'expired_trader_payment_confirm' | 'cancelled_by_user' | 'completed' | 'completed_by_admin' | 'cancelled_by_admin'

export type OrderStatusBadge = {
	color: string,
	variant: string,
	label: string,
	tooltip_text: string,
}

export const order_status_badge_map: Record<OrderStatus,OrderStatusBadge> = {
	completed: {
		color: 'green',
		variant: 'solid',
		label: 'Успешно завершена',
		tooltip_text: 'Заявка успешно завершена',
	},
	completed_by_admin: {
		color: 'green',
		variant: 'soft',
		label: 'Успешно завершена (администратор)',
		tooltip_text: 'Заявка успешно завершена администратором',
	},
	payment_confirmation_wait: {
		color: 'blue',
		variant: 'solid',
		label: 'Ожидает подтверждения оплаты',
		tooltip_text: 'Оплата заявки произведена, ожидает подтверждения трейдером',
	},
	new: {
		color: 'amber',
		variant: 'solid',
		label: 'Ожидает оплаты от пользователя',
		tooltip_text: 'Заявка создана, ожидает оплаты',
	},
	expired_payment_wait: {
		color: 'gray',
		variant: 'solid',
		label: 'Просрочена оплата пользователем',
		tooltip_text: 'Пользователь не подтвердил оплату заявки в установленное время',
	},
	expired_trader_payment_confirm: {
		color: 'gray',
		variant: 'solid',
		label: 'Просрочена подтверждение трейдером',
		tooltip_text: 'Трейдер не подтвердил оплату заявки в установленное время',
	},
	cancelled_by_user: {
		color: 'gray',
		variant: 'solid',
		label: 'Отменена пользователем',
		tooltip_text: 'Пользователь отменил заявку',
	},
	cancelled_by_admin: {
		color: 'red',
		variant: 'soft',
		label: 'Отменена администратором',
		tooltip_text: 'Администратор отменил заявку',
	},

}

// SALARY_LEAD_CEO_MICHAEL_KOVSHOV
// SALARY_LEAD_ASSISTANT_ALMIRA_AMANTAEVA
// SALARY_LEAD_PARTNER_ALINA_DEMIRCI
// SALARY_CL_COO_DENIS_GUSEV
// SALARY_CL_COO_IVAN_CHERNYKH
// SALARY_CL_CFO_EUGENE_RYCHKOV
// SALARY_CL_CTO_KONSTANTINE_ANDRYUNIN
// SALARY_DEV_BACKEND_IGOR_KORSAKOV
// SALARY_DEV_BACKEND_DANIEL_CARPOV
// SALARY_DEV_BACKEND_ALEX_UDODOV
// SALARY_DEV_FRONTEND_ILYA_YABLOKOV
// SALARY_DEV_QA_SERGEY_CHEREVATYY
// SALARY_MARKET_TEAM_LEAD_VLAD_POLIAKOV
// SALARY_DES_DES_DMITRI_KNYAGININ
// SALARY_DES_DES_UX/UI_UANT_MAXIM_ZVARICI
// SALARY_SUPP_TEAM_LEAD_ALEXANDER_EYDELSHTEIN
// SALARY_SUPP_TECH_REVIEW_PAVEL_POLIAKOV
// SALARY_SUPP_MANAGER_ALINA_MKHOYAN
// SALARY_SUPP_MANAGER_YANA_MOTORINA
// SALARY_SUPP_MANAGER_ROMAN_KISELEV
// SALARY_SUPP_MANAGER_SERGEY_ZAKHAROV
// SALARY_SUPP_MANAGER_KONSTANTINE_YANDULSKY
export const expense_category: Record<string, { title: string, variant: string, color: string }> = {
	"OTHER_EXP": {
		"title": "Другое",
		"variant": "solid",
		"color": "gray"
	},
	"ASINX": {
		"title": "ASINX",
		"variant": "solid",
		"color": "blue"
	},
	"ARTHA": {
		"title": "ARTHA",
		"variant": "solid",
		"color": "sky"
	},
	"TRX_BCB": {
		"title": "TRX BCB",
		"variant": "solid",
		"color": "green"
	},
	"TRX_MM": {
		"title": "TRX MM",
		"variant": "solid",
		"color": "yellow"
	},
	"SALARY": {
		"title": "Зарплата",
		"variant": "solid",
		"color": "violet"
	},
	"DEV_EXP": {
		"title": "Dev Exp",
		"variant": "solid",
		"color": "purple"
	},
	"TRIP_EXP": {
		"title": "Trip Exp",
		"variant": "solid",
		"color": "orange"
	},
	"MARKET": {
		"title": "Market",
		"variant": "solid",
		"color": "pink"
	},
	"MLM": {
		"title": "MLM",
		"variant": "solid",
		"color": "teal"
	},
	"INVESTMENT": {
		"title": "Investment",
		"variant": "solid",
		"color": "cyan"
	},
	"REFUND": {
		"title": "REFUND",
		"variant": "solid",
		"color": "fuchsia"
	},
	"CONV": {
		"title": "CONV",
		"variant": "solid",
		"color": "indigo"
	},
	"PTI": {
		"title": "PTI",
		"variant": "solid",
		"color": "lime"
	},
	// "MICHAEL": {
	// 	"title": "Michael",
	// 	"variant": "solid",
	// 	"color": "amber"
	// },
	// "ALINA": {
	// 	"title": "Alina",
	// 	"variant": "solid",
	// 	"color": "lime"
	// }
	"SALARY_LEAD_CEO_MICHAEL_KOVSHOV": {
		"title": "ЗП CEO Michael Kovshov",
		"variant": "solid",
		"color": "primary"
	},
	"SALARY_LEAD_ASSISTANT_ALMIRA_AMANTAEVA": {
		"title": "ЗП Assistant Almira Amantaeva",
		"variant": "solid",
		"color": "primary"
	},
	"SALARY_LEAD_PARTNER_ALINA_DEMIRCI": {
		"title": "ЗП Partner Alina Demirci",
		"variant": "solid",
		"color": "primary"
	},
	"SALARY_CL_COO_DENIS_GUSEV": {
		"title": "ЗП COO Denis Gusev",
		"variant": "solid",
		"color": "primary"
	},
	"SALARY_CL_COO_IVAN_CHERNYKH": {
		"title": "ЗП COO Ivan Chernykh",
		"variant": "solid",
		"color": "primary"
	},
	"SALARY_CL_CFO_EUGENE_RYCHKOV": {
		"title": "ЗП CFO Eugene Rychkov",
		"variant": "solid",
		"color": "primary"
	},
	"SALARY_CL_CTO_KONSTANTINE_ANDRYUNIN": {
		"title": "ЗП CTO Konstantine Andryunin",
		"variant": "solid",
		"color": "primary"
	},
	"SALARY_DEV_BACKEND_IGOR_KORSAKOV": {
		"title": "ЗП Backend Igor Korsakov",
		"variant": "solid",
		"color": "primary"
	},
	"SALARY_DEV_BACKEND_DANIEL_CARPOV": {
		"title": "ЗП Backend Daniel Carpov",
		"variant": "solid",
		"color": "primary"
	},
	"SALARY_DEV_BACKEND_ALEX_UDODOV": {
		"title": "ЗП Backend Alex Udodov",
		"variant": "solid",
		"color": "primary"
	},
	"SALARY_DEV_FRONTEND_ILYA_YABLOKOV": {
		"title": "ЗП Frontend Ilya Yablokov",
		"variant": "solid",
		"color": "primary"
	},
	"SALARY_DEV_QA_SERGEY_CHEREVATYY": {
		"title": "ЗП QA Sergey Cherevatyy",
		"variant": "solid",
		"color": "primary"
	},
	"SALARY_MARKET_TEAM_LEAD_VLAD_POLIAKOV": {
		"title": "ЗП Market Team Lead Vlad Poliakov",
		"variant": "solid",
		"color": "primary"
	},
	"SALARY_DES_DES_DMITRI_KNYAGININ": {
		"title": "ЗП DES Dmitri Knyaginin",
		"variant": "solid",
		"color": "primary"
	},
	"SALARY_DES_DES_UX/UI_UANT_MAXIM_ZVARICI": {
		"title": "ЗП DES UX/UI Uant Maxim Zvarici",
		"variant": "solid",
		"color": "primary"
	},
	"SALARY_SUPP_TEAM_LEAD_ALEXANDER_EYDELSHTEIN": {
		"title": "ЗП Team Lead Alexander Eydelshtein",
		"variant": "solid",
		"color": "primary"
	},
	"SALARY_SUPP_TECH_REVIEW_PAVEL_POLIAKOV": {
		"title": "ЗП Tech Review Pavel Poliakov",
		"variant": "solid",
		"color": "primary"
	},
	"SALARY_SUPP_MANAGER_ALINA_MKHOYAN": {
		"title": "ЗП Manager Alina Mkhoyan",
		"variant": "solid",
		"color": "primary"
	},
	"SALARY_SUPP_MANAGER_YANA_MOTORINA": {
		"title": "ЗП Manager Yana Motorina",
		"variant": "solid",
		"color": "primary"
	},
	"SALARY_SUPP_MANAGER_ROMAN_KISELEV": {
		"title": "ЗП Manager Roman Kiselev",
		"variant": "solid",
		"color": "primary"
	},
	"SALARY_SUPP_MANAGER_SERGEY_ZAKHAROV": {
		"title": "ЗП Manager Sergey Zakharov",
		"variant": "solid",
		"color": "primary"
	},
	"SALARY_SUPP_MANAGER_KONSTANTINE_YANDULSKY": {
		"title": "ЗП Manager Konstantine Yandulsky",
		"variant": "solid",
		"color": "primary"
	},
	'SALARY_SUPP_SUPERVISOR_ALINA_MKHOYAN': {
		"title": "ЗП Supervisor Alina Mkhoyan",
		"variant": "solid",
		"color": "primary"
	},
	'SALARY_DES_DES_KIRILL_ASLANIDZE': {
		"title": "ЗП DES Kirill Aslanidze",
		"variant": "solid",
		"color": "primary"
	},
	'SALARY_DEV_QA_MIKHAIL_GUDKOV': {
		"title": "ЗП QA Mikhail Gudkov",
		"variant": "solid",
		"color": "primary"
	},
	'SALARY_DES_DES_INSAF_KARIMOV': {
		"title": "ЗП DES Insaf Karimov",
		"variant": "solid",
		"color": "primary"
	},

	'SALARY_SALES_HSD_KIRILL_KOTEGOV': {
		"title": "ЗП Sales HSD Kirill Kotegov",
		"variant": "solid",
		"color": "primary"
	},
	'SALARY_BUSINESS_ANALYST_ULIA_RADIONOVA': {
		"title": "ЗП Business Analyst Ulia Radionova",
		"variant": "solid",
		"color": "primary"
	},
	'SALARY_PRODUCT_MANAGER_ANNA_DJERMOUN': {
		"title": "ЗП Product Manager Anna Djermoun",
		"variant": "solid",
		"color": "primary"
	},
	'SALARY_HR_DIR_NATALYA_CHEKRYGINA': {
		"title": "ЗП HR Director Natalya Chekrygina",
		"variant": "solid",
		"color": "primary"
	},
	'SALARY_MARKET_SMM_ROSTISLAV_RESHETNIKOV': {
		"title": "ЗП Market SMM Rostislav Reshetnikov",
		"variant": "solid",
		"color": "primary"
	},
	'SALARY_DEV_FRONTEND_VLAD_BUGORKOV': {
		"title": "ЗП Frontend Vlad Bugorkov",
		"variant": "solid",
		"color": "primary"
	}

}

export interface ApiResponse<T = any> {
  success: boolean;
  item?: T;
  items?: T[];
  users?: Record<string, User>;
  meta?: {
    collection_items_count: number;
    filter_items_count: number;
    limit: number;
    skip: number;
    sort: Record<string, any>;
  };
  cs?: Record<string, any>;
  traceback?: string;
}